@if(isPageRestrictionLoaded) {
<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility" tabindex="-1" pplAutoFocusHeader>Pended Timesheets</h1>
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    @if(processCodes && processCodes.length) {
                    <ppl-timesheet-filter [filterFields]="fields" (searchEvent)="onSearch($event)"
                        [processCodes]="processCodes" [initialValues]="filterInitialValues" [assignedToUsers]="listOfUsers"></ppl-timesheet-filter>
                    <p class="pl-2"> <span class="error-message1" [attr.aria-label]="'Required'">*</span> Atleast one out of the following fields
                        should be populated: <b>Consumer Name</b>, <b>Consumer PPL ID</b>, <b>Provider Name</b>,
                        <b>Provider PPL ID</b>, <b>Assignee</b>.</p>
                    <div>
                        <p><strong>Note:</strong></p>
                        <ul>
                            <li>For <strong>Deny</strong> and <strong>Override</strong> actions, please select the
                                applicable timesheets.</li>
                            <li>The <strong>Deny All</strong> and <strong>Override All</strong> actions will update all
                                timesheets that match the search criteria.</li>
                        </ul>
                    </div>
                    }
                </div>
                <div class="table-style">
                    @if(timesheets.length > 0) {
                    <ppl-list-table [cols]="cols" [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false"
                        [data]="timesheets" [customDataLoaded]="true" [enableActions]="true" [from]="'timesheet'"
                        [gridTitle]="false" [pagination]="true" [loadPage]="true" (onPageLoad)="onPageLoad($event)"
                        [actionButtons]="actionButtons" (rowDetailEvent)="rowClicked($event)" [enablePageActions]="true"
                        [listButton]="buttons" [timesheetFor]="'pendedTimesheet'" (actionInvoked)="gridAction($event)"
                        (gridAction)="action($event)">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                        find the records</div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-container>
}

<div class="filter-panel">
    <ng-template #pendedDialog let-cancel="cancel">
        <ppl-timesheet-staff-errorcode [errorcodeData]="errorcodeData" (onSaveComplete)="onSaveAdjustment($event)"
            [disabled]="disableEditingPendedTimesheet" [disabled]="isReadOnly"></ppl-timesheet-staff-errorcode>
    </ng-template>
</div>

<ppl-popup-dialog [(isVisible)]="showActionPopup" [title]="title" [isOkText]="okText" (confirm)="handleOk()"
    (cancel)="handleCancel()" [showButtons]="true" [showOkButton]="false" [size]="'medium'" [position]="'top'">

    <form nz-form [formGroup]="timesheetActionForm">
        <!-- Assign to User Field -->
        <div nz-row *ngIf="isAssignToUser">
            <div nz-col style="margin-left: 8px; margin-right: 8px; width: 100%;">
                <nz-form-item>
                    <nz-form-control>
                        <ppl-multiselect *ngIf="selectedCheckboxes?.length > 1; else singleUserSelect"
                            [(ngModel)]="selectedUsers" [ngModelOptions]="{standalone: true}" style="width:100%;"
                            [options]="listOfUsers" [showClear]="false" placeholder="Please select User">
                        </ppl-multiselect>
                        <ng-template #singleUserSelect>
                            <ppl-dropdown-select [(ngModel)]="selectedUsers" [ngModelOptions]="{standalone: true}"
                                style="width:100%;" [options]="listOfUsers" [showClearButton]="false"
                                placeholder="Please select User">
                            </ppl-dropdown-select>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>

        <!-- Selected Process Code Field -->
        <div nz-row>
            <div nz-col *ngIf="!isAssignToUser && timesheetActionForm.controls['selectedProcessCode']"
                style="margin-left: 8px; margin-right: 8px;width: 100%;">
                <nz-form-item>
                    <nz-form-control>
                        <nz-select [nzMode]="'multiple'" formControlName="selectedProcessCode" class="filters"
                            id="selectedProcessCode" nzPlaceHolder="Select Process Code" nzShowSearch
                            style="width: 100%;"
                            [nzStatus]="timesheetActionForm.get('selectedProcessCode')?.invalid && timesheetActionForm.get('selectedProcessCode')?.touched ? 'error' : ''">
                            <nz-option *ngFor="let opt of allowedProcessCodes" [nzLabel]="opt.displayName"
                                [nzValue]="opt.code">
                            </nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <div style="margin-left: 8px; margin-right: 8px;width: 100%;"
            *ngIf="timesheetActionForm.get('selectedProcessCode')?.invalid && timesheetActionForm.get('selectedProcessCode')?.touched">
            <div class="error-message">Please select a process code.</div>
        </div>

        <!-- Reason Field -->
        <div nz-row>
            <div nz-col *ngIf="!isAssignToUser && timesheetActionForm.controls['reason']"
                style="margin-left: 8px; margin-right: 8px;width: 100%;">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="'Please select a reason'">
                        <div style="width: 100%;" class="filters" [ngClass]="{'error': timesheetActionForm.get('reason')?.invalid && timesheetActionForm.get('reason')?.touched}">
                            <ppl-dropdown-select formControlName="reason" id="reason" placeholder="Select Reason"
                            [options]="reasonList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
                            </ppl-dropdown-select>
                        </div>
                    </nz-form-control>

                </nz-form-item>
            </div>
        </div>

        <div style="margin-left: 8px; margin-right: 8px;width: 100%;"
            *ngIf="timesheetActionForm.get('reason')?.invalid && timesheetActionForm.get('reason')?.touched">
            <div class="error-message">Please select a reason.</div>
        </div>

        <!-- Comments Field -->
        <div nz-row>
            <div nz-col *ngIf="!isAssignToUser && timesheetActionForm.controls['comments']"
                style="margin-left: 8px; margin-right: 8px; width: 100%;">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="'Please select a reason'">
                        <label for="comments" class="field-header">Comments</label>
                        <nz-textarea-count [nzMaxCharacterCount]="10000">
                            <textarea rows="3" nz-input id="comments" formControlName="comments"
                                placeholder="Start typing..." [maxlength]="10000"
                                [nzStatus]="timesheetActionForm.get('comments')?.invalid && timesheetActionForm.get('comments')?.touched ? 'error' : ''"></textarea>
                        </nz-textarea-count>
                        <div
                            *ngIf="timesheetActionForm.get('comments')?.invalid && timesheetActionForm.get('comments')?.touched">
                            <div class="error-message">Please enter a message.</div>
                        </div>
                    </nz-form-control> </nz-form-item>
            </div>
        </div>
    </form>

</ppl-popup-dialog>

<div class="filter-panel">
    <ng-template #confirmationDialog let-cancel="cancel">
        <p> This action will apply to all timesheets that meet the search criteria. Do you want to continue?</p>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #historyDialog let-cancel="cancel">
        @if(timesheetHistoryData?.length > 0) {
        <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="false"
            [data]="timesheetHistoryData" [disableSelection]="true" [cols]="timesheetHistoryCols" [gridTitle]="false"
            [pagination]="true" [loadPage]="false">
        </ppl-list-table>
        } @else {
        No Data Available
        }
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #warningDialog let-cancel="cancel">
        <p> Atleast one out of the following fields should be populated: Consumer Name, Consumer PPL ID, Provider Name,
            Provider PPL ID, Assignee</p>
    </ng-template>
</div>